import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders} from '@angular/common/http';

import { Observable } from 'rxjs';
import 'rxjs/add/observable/of';

import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import {Router} from '@angular/router';
import { User } from './User';
import { Token } from './Token';
import {YoutubePlaylist} from './YoutubePlaylist'
import {DomSanitizer} from '@angular/platform-browser/';

@Injectable()
export class DatabaseGetterService {
	
	public  captcha;
	public endpoint = 'https://apolion.games:9090';
	public errorMsg;
	public listData;
	public loadedData = false;
	public limitPerPage = 25;
	public accesstoken = "";
	public playlist;
	public loadedPlaylist = false;
	constructor(private http:HttpClient,private router:Router,private sanitizer: DomSanitizer) { 
	}
	registerUser(user : User):Observable<Token>{
		const httpOptions = {
			headers: new HttpHeaders({
			  'Content-Type':  'application/json',
			  'g-recaptcha-response':this.captcha
			})
		  };
		let a : Observable<Token> = this.http.post<Token>(this.endpoint+'/register',user,httpOptions);
		a.subscribe(
		data => {
			console.log(data)
		},
		error => {
			this.loadedData=true;
			this.errorMsg = error
			console.log(error)
		});	
		return a;
	}
	getToken(user : User):Observable<Token>{
		let a : Observable<Token> = this.http.post<Token>(this.endpoint+'/login',user);
		a.subscribe(
		data => {
			this.accesstoken=data['token'];
			console.log(this.accesstoken)
		},
		error => {
			this.loadedData=true;
			this.errorMsg = error
			console.log(error)
		});	
		return a;
	}
	getUsers():Observable<User[]>{
		let a : Observable<User[]> = this.http.get<User[]>(this.endpoint+'/users',{
				headers: {'accesstoken':this.accesstoken}
		});
		a.subscribe(
		data => {
			this.listData=data;
			this.loadedData=true;
			console.log("loaded data");
		},
		error => {
			this.errorMsg = error
		});	
		return a;
	}
	
	getYoutubeVideos(){
		let a : Observable<YoutubePlaylist> = this.http.get<YoutubePlaylist>('https://www.googleapis.com/youtube/v3/playlistItems?part=contentDetails&playlistId=PL-adq2z_Lky_4fjk9r2W1A8WjduaYUByX&key=AIzaSyDXCDiwzvvC0hgqXatyZyWdiViORRV54Bs',{
		});
		a.subscribe(
		data => {
			this.playlist=data.items;
			this.loadedPlaylist=true;
			console.log("loaded data");
		},
		error => {
			this.errorMsg = error
		});	
		return a;
	}
	
}
